export const LEGAL_LINKS = [
  { href: "/legal/terms-of-service", label: "Terms of Service" },
  { href: "/legal/privacy-policy", label: "Privacy Policy" },
  { href: "/legal/dpa", label: "Data Processing Addendum" },
  { href: "/legal/security", label: "Security Policy" },
  { href: "/legal/cookie-policy", label: "Cookie Policy" },
  { href: "/legal/ai-policy", label: "Kroolo AI Policy" },
  { href: "/legal/msa", label: "Master Services Agreement" },
] as const;
